import { render, staticRenderFns } from "./Slabs.vue?vue&type=template&id=3d2874d3&scoped=true"
import script from "./Slabs.vue?vue&type=script&lang=js"
export * from "./Slabs.vue?vue&type=script&lang=js"
import style0 from "./Slabs.vue?vue&type=style&index=0&id=3d2874d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2874d3",
  null
  
)

export default component.exports